import { CL_CONFIRMED_ACTION, CL_FAILED_ACTION } from "../actions/actionTypes";


const initialState = {
    data: [],
    errorMessage: '',
    successMessage: '',
    showLoading: false,
};

export function ContractLocationReducer(state = initialState, action) {
    if (action.type === CL_CONFIRMED_ACTION) {
        return {
            ...state,
            data: action.payload,
            errorMessage: '',
            successMessage: 'contract location fetched successfully',
            showLoading: false,
        };
    } else if (action.type === CL_FAILED_ACTION) {

        return {
            ...state,
            errorMessage: action.payload,
            successMessage: '',
            showLoading: false,
        };
    }
    else {
        return state;
    }
}
